
const formData = {
    getUpdates: ["US", "HK", "MO", "AU", "NZ", "MX", "CN", "KR"],
    eInterest: ["US"],
    phoneNr: {
        "MX": "+52",
        "BE": "+32",
        "CZ": "+420",
        "DK": "+45",
        "DE": "+49",
        "ES": "+34",
        "FR": "+33",
        "IE": "+353",
        "IT": "+39",
        "LU": "+352",
        "NL": "+31",
        "NO": "+47",
        "AT": "+43",
        "PT": "+351",
        "FI": "+358",
        "SE": "+46",
        "CH": "+41",
        "GB": "+44",
        "HK": "+852",
        "MO": "+853",
        "TW": "+886",
        "JP": "+81",
        "KR": "+82",
        "AU": "+61",
        "NZ": "+64",
        "CN": "+86"
    }
}

export default formData;
